import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-meetings',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="Meetings" apiPath="v1/meetings" />`
})
export class MeetingsComponent {}
